import { render, staticRenderFns } from "./pg_recruit.vue?vue&type=template&id=832e5930"
import script from "./pg_recruit.vue?vue&type=script&lang=js"
export * from "./pg_recruit.vue?vue&type=script&lang=js"
import style0 from "./pg_recruit.vue?vue&type=style&index=0&id=832e5930&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports